import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/ui-common/src/CircularProgress/CircularProgress.styled.ts",
    _templateObject2,
    _templateObject3,
    _templateObject4,
    _templateObject5,
    _templateObject6;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css, keyframes } from 'styled-components';
var keyframesCircularRotate = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n100%{\ntransform: rotate(360deg);\n}\n"])));
export var CircularProgressWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  animation: ", " 1.4s linear infinite;\n  display: inline-block;\n  color: ", ";\n"])), keyframesCircularRotate, function (props) {
  switch (props.color) {
    case 'primary':
      return '#3f51b5';

    case 'secondary':
      return '#f50057';

    case 'inherit':
      return 'inherit';
  }
});
export var SVGWrapper = styled.svg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: block;\n"])));
var keyframesCircularDash = keyframes(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n0%{\n  stroke-dasharray: 1px, 200px;\n  stroke-dashoffset: 0px;\n}\n50%{\n  stroke-dasharray: 100px, 200px;\n  stroke-dashoffset: -15px;\n}\n100%{\n  stroke-dasharray: 100px, 200px;\n  stroke-dashoffset: -125px;\n}\n"])));
export var CircleWrapper = styled.circle(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  stroke: currentColor;\n  stroke-dashoffset: 0px;\n  stroke-dasharray: 80px, 200px;\n  animation: ", ";\n"])), function (props) {
  return props.disableShrink ? 'unset' : css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n          ", " 1.4s ease-in-out infinite\n        "])), keyframesCircularDash);
});